import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { MEDIA_TYPE_VIDEO } from 'src/lib/media'
import Pressable from 'src/ui/Pressable/Pressable'
import MediaModal from 'src/ui/Modals/MediaModal/MediaModal'

const MediaPlayableInModal = ({
  type = MEDIA_TYPE_VIDEO,
  title,
  mediaUrl,
  mediaSize,
  children,
  ...rest
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleToggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  return (
    <>
      <Pressable
        onClick={handleToggleModal}
        altText={type}
        display="block"
        width="100%"
        borderRadius="0,5x"
        {...rest}
      >
        {children}
      </Pressable>
      <MediaModal
        type={type}
        sourceUrl={mediaUrl}
        {...mediaSize}
        playing
        title={title}
        isOpen={isModalOpen}
        onHide={handleToggleModal}
      />
    </>
  )
}

MediaPlayableInModal.propTypes = {
  type: PropTypes.oneOf([MEDIA_TYPE_VIDEO]),
  title: PropTypes.string.isRequired,
  mediaUrl: PropTypes.string,
  mediaSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default MediaPlayableInModal
